<div class="reg-group">
    <div class="reg-tit-box">
        <div class="reg-tit-txt">
            {{ "search.bookmarkManager.title" | translate }}
        </div>
        <div class="reg-menu">
            <a class="cancel-btn" (click)="close()">
                {{ "search.bookmarkManager.cancelButton" | translate }}
            </a>
            <a class="reg-success-btn" (click)="add()">
                {{ "search.bookmarkManager.confirmButton" | translate }}
            </a>
        </div>
    </div>
    <div class="reg-form-box" *ngIf="pointDto">
        <div class="row">
            <div class="subject">
                {{ "search.bookmarkManager.placeName" | translate }}
            </div>
            <div class="con">
                <input type="text" class="full" [(ngModel)]="pointDto!.name" />
                <div class="msg-box">
                    <div class="msg-txt" *ngIf="!pointDto.isValidPlaceName()">
                        {{ "search.bookmarkManager.invalidPlaceName" | translate }}
                    </div>
                </div>
            </div>
        </div>
        <div class="row" [class.msg]="!pointDto.isValidPlaceName()">
            <div class="subject">
                {{ "search.bookmarkManager.address" | translate }}
            </div>
            <div class="con">
                <input type="text" class="full" [(ngModel)]="pointDto!.address" />
            </div>
        </div>
        <div class="row">
            <div class="subject">
                {{ "search.bookmarkManager.altitude" | translate }}
            </div>
            <div class="con">
                <input type="number" [(ngModel)]="pointDto!.altitude" />
                <span class="unit">
                    m
                </span>
            </div>
        </div>
    </div>
</div>
